import { sessionStorage } from '../../../utils/storageUtils';
import { Datastore } from '../models/datastore';

const getStorageKey = (storagePrefix: string) => `${storagePrefix}-curriculum-onboarding`;

export const getStoredDatastore = (prefix: string) => sessionStorage.getItem(getStorageKey(prefix)) || {};

export const updateDatastore = (prefix: string, current: Datastore, data: Partial<Datastore>) => {
  const updatedData = { ...current, ...data };
  sessionStorage.setItem(getStorageKey(prefix), updatedData);
  return updatedData;
};

export const deleteDatastore = (prefix: string) => {
  sessionStorage.removeItem(getStorageKey(prefix));
  return {};
};
